export function createEventReplayControlClient(transport) {
    return {
        /**
         * List every tenant's replay jobs, as a state, a stream and four counts
         *
         * Requires scope: event-replay:platform:read
         */
        listPlatformEventReplays(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/event-replays",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/event-replays
         *
         * Requires scope: event-replay:plan
         */
        planEventReplay(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/event-replays`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/event-replays/{replayId}
         *
         * Requires scope: event-replay:read
         */
        getEventReplay(tenantId, replayId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/event-replays/${encodeURIComponent(replayId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/event-replays/{replayId}/approve
         *
         * Requires scope: event-replay:approve
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        approveEventReplay(tenantId, replayId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/event-replays/${encodeURIComponent(replayId)}/approve`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/event-replays/{replayId}/start
         *
         * Requires scope: event-replay:start
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        startEventReplay(tenantId, replayId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/event-replays/${encodeURIComponent(replayId)}/start`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/event-replays/{replayId}/checkpoints
         *
         * Requires scope: event-replay:checkpoint
         */
        checkpointEventReplay(tenantId, replayId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/event-replays/${encodeURIComponent(replayId)}/checkpoints`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=event-replay-control.js.map